import { useEffect } from 'react';
import { useProject } from '~src/hooks/api-hooks/useProject';
import { useProjectId } from '~src/hooks/useProjectId';
import { APP_VERSION } from '~src/config/app-version';

/**
 * Manages the browser document title based on current project context.
 * Shows "{project name} C-WEB" when inside a project,
 * falls back to "C-WEB Projekt v{VERSION}" otherwise.
 */
export const DocumentTitleManager = () => {
  const projectId = useProjectId();
  const projectQuery = useProject();

  useEffect(() => {
    if (projectId && projectQuery.data?.name) {
      window.document.title = `${projectQuery.data.name} C-WEB`;
    } else {
      window.document.title = `C-WEB Projekt v${APP_VERSION}`;
    }
  }, [projectId, projectQuery.data?.name]);

  return null;
};
